
import * as OM from '@/model';
import * as ENUM from '@/enum';
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';
import { ProjectConfigClient } from '@/services/Services';
import store from '@/store';

@Options({})
export default class userPaymentData extends mixins(WithModel) {

    declare localValue: OM.UserPaymentData;

    modalitaPagamentos: OM.PaymentRequestMethodDetails[] = [];

    created(){
        ProjectConfigClient.getPaymentRequestMethods()
        .then(x => {
            this.modalitaPagamentos = x;
        })
    }

    get details(){
        return this.modalitaPagamentos.find(x => x.name == this.localValue.modalitaPagamento);
    }

}
